export const SEVICEABILITIES_RESET_STATE = 'SEVICEABILITIES_RESET_STATE';
export const SEVICEABILITIES_CURRENT_ITEM = 'SEVICEABILITIES_CURRENT_ITEM';

export const SEVICEABILITIES_REQUEST_LOADING = 'SEVICEABILITIES_REQUEST_LOADING';
export const SEVICEABILITIES_REQUEST_SUCCESS = 'SEVICEABILITIES_REQUEST_SUCCESS';
export const SEVICEABILITIES_REQUEST_FAILED = 'SEVICEABILITIES_REQUEST_FAILED';

export const SEVICEABILITIES_CURRENT_ACTION = 'SEVICEABILITIES_CURRENT_ACTION';
export const SEVICEABILITIES_RESET_ACTION = 'SEVICEABILITIES_RESET_ACTION';